import { Grid } from '@material-ui/core';
import React from 'react';
import { styles } from './summary-styles';
import { useTranslation } from 'react-i18next';

export interface SummaryProps {
  heading: string;
  value: string | number;
  marginNeeded: boolean;
}

export const Summary = ({ heading, value, marginNeeded }: SummaryProps): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();
  return (
    <Grid item container className={classes.summaryContainer}>
      <Grid
        className={`${classes.summaryHeading} ${marginNeeded ? classes.summaryMargin : ''}`}
        item
        data-testid='action-window-total-label'
      >
        {`${t(heading)}:`}
      </Grid>
      <Grid item data-testid='action-window-total-value' className={classes.summaryValue}>
        {value}
      </Grid>
    </Grid>
  );
};
